import {getCurrentYear} from '../../utils/commons'
import TheBestTechPicksLogo from './logo'
import theBestTechPicksStylesUS from './styles'

const baseConfig = {
  domainName: 'thebesttechpicks' as const,
  domainType: 'picks' as const,
  siteName: 'The Best Tech Picks',
  logo: <TheBestTechPicksLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/thebesttechpicks.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-K6FXM5STK6',
    camelCaseUrl: 'TheBestTechPicks.com',
    title: (category: string, _count: string) =>
      `${category} Worth Buying in ${getCurrentYear()} — Our Top Picks | TheBestTechPicks.com`,
    description: (_category?: string, _count?: string) =>
      `Find the best tech essentials with expert reviews and comparisons. Discover top-rated items at today's lowest prices, all in one place!`,
    styles: theBestTechPicksStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
